<template>
  <div class="recordsJustifForm">
    <records-justif-file-input
      v-for="document in requiredDocuments"
      :key="document.id"
      :document="document"
      :person="person"
    />
    <!-- Using a slot to avoid handling text inside a functionnal component -->
    <slot />
    <records-justif-file-input
      v-for="document in facultativeDocuments"
      :key="document.id"
      :document="document"
      :person="person"
    />
  </div>
</template>

<script>
import RecordsJustifFileInput from './RecordsJustifFileInput'
import { mapState } from 'vuex'

export default {
  name: "RecordsJustifForm",
  components: {
    RecordsJustifFileInput
  },
  props: {
    person: {
      type: Object,
      required: true
    }
  },
  computed: {
    ...mapState({
      currentRecordTenantsDocuments: state => state.recordsDocuments.currentRecordTenantsDocuments,
      currentRecordGuarantorsDocuments: state => state.recordsDocuments.currentRecordGuarantorsDocuments
    }),
    personDocuments() {
      if (this.person) {
        return {
          ...this.currentRecordTenantsDocuments,
          ...this.currentRecordGuarantorsDocuments
        }[this.person.id]
      }

      return null
    },
    requiredDocuments() {
      if (this.personDocuments) {
        return this.personDocuments.filter(item => item.required)
      }

      return null
    },
    facultativeDocuments() {
      if (this.personDocuments) {
        return this.personDocuments.filter(item => !item.required)
      }

      return null
    },
    recordId() {
      if (this.$route && this.$route.params && this.$route.params.id) {
        return parseInt(this.$route.params.id)
      }

      return null
    }
  }
}
</script>
